function getCookie(name) {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop().split(';').shift();
    return null;
}

function getAccessLevel() {
    const userAccessJson = getCookie('user_access');
    const selectedCompanyId = getCookie('selected_company');
    if (userAccessJson) {
        const userAccessArray = JSON.parse(decodeURIComponent(userAccessJson));
        if (Array.isArray(userAccessArray) && selectedCompanyId) {
            for (const access of userAccessArray) {
                if (access.company_id == selectedCompanyId) {
                    return access.access_level;
                }
            }
        }
    }

    return false;
}

function isUserAdmin() {
    const accessLevel = getAccessLevel();
    return accessLevel === 'admin';
}

function isUserEditor() {
    const accessLevel = getAccessLevel();
    return accessLevel === 'edit';
}

function isUserViewer() {
    const accessLevel = getAccessLevel();
    return accessLevel === 'view';
}

// Exporting all functions
export { getCookie, getAccessLevel, isUserAdmin, isUserEditor, isUserViewer };
